import { useState, useEffect } from 'react';
import { Container } from './StaticImage.styles';

type OwnProps = {
  image: string;
  isVisible: boolean;
};

const StaticVehicle = ({ image, isVisible }: OwnProps) => {
  const [isHidden, setHidden] = useState(false);
  const [isRemoved, setRemoved] = useState(false);

  useEffect(() => {
    setHidden(!isVisible);
    const t = setTimeout(() => {
      setRemoved(!isVisible);
    }, 1000);

    return () => {
      clearTimeout(t);
    };
  }, [isVisible, setHidden]);

  if (isRemoved) return null;

  return (
    <Container className={isHidden ? 'opacity-0' : 'opacity-100'}>
      <img className="top-0 z-1 w-full" src={image} alt="jaxsons-bike" />
    </Container>
  );
};

export default StaticVehicle;
